import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Cabecalho from './Cabecalho';

import Login from './Login';
import Resultados from './Resultados';
import ResultadosFiltro from './ResultadosFiltro';
import AlterarSenha from './AlterarSenha';
import RecuperarSenha from './RecuperarSenha';

import { Container } from 'semantic-ui-react';

const Main = () => (
    <Container fluid >
        <Cabecalho />
        <Container >
            <Switch >
                <Route exact path='/' component={Login} />
                <Route path='/resultados' component={Resultados} />
                <Route path='/resultadosFiltro' component={ResultadosFiltro} />
                <Route path='/alterarSenha' component={AlterarSenha} />
                <Route path='/recuperarSenha' component={RecuperarSenha} />
                <Redirect to='/' />
            </Switch>
        </Container>
    </Container>
)

export default Main;